import { DESKTOP_BREAKPOINT } from 'pages/_app';
import { BlocksMediaType, MediaBlock } from '../mediaBlock/MediaBlock';
import { DefaultBlockProps, DefaultMediaBlockProps } from '../switchBlock/SwitchBlock';
import { BlocksTextType, TextBlock } from '../textBlock/TextBlock';
import style from './MixedBlock.module.scss';

export type BlocksMixedType = DefaultBlockProps & {
  block_type: 'mixed';
  text: string;
  media: DefaultMediaBlockProps;
};

export const MixedBlock = (props: BlocksMixedType): JSX.Element | null => {
  // Child media always 50% width
  // Child text always 50% width
  // Text left/right determined by text_position
  // rester the textblock alignment though

  const mediaProps: BlocksMediaType = {
    media: props.media,
    block_type: 'media',
    layout: 'responsive',
  };
  const textProps: BlocksTextType = { block_type: 'text', media: [], text: props.text };

  // const containerState = props.text_position === 'right' ? style.containerIstextRight : null;
  return (
    <div className={`${style.container} block-mixed`}>
      <div className={`${style.media} `}>
        <MediaBlock
          {...mediaProps}
          sizes={`${DESKTOP_BREAKPOINT} 40vw,
                  100vw`}
        />
      </div>

      <div className={`${style.text} `}>
        <TextBlock {...textProps} />
      </div>
    </div>
  );

  return null;
};
